/**
 * Service/Eb (Ebaas) Controller
 *
 * Displays information about Ebaas orders
 */

// the constructor for this object
function ServiceEbController() { }

// the object
ServiceEbController.prototype = {
    constructor: ServiceEbController,
    
    // the base order id
    baseOrderId: false,
    
    // store the agent client count chart object here
    agentClientCountChart: false,
    
    // store the agent protected stats chart object here
    agentProtectedChart: false,
    
    // store the image client count chart object here
    imageClientCountChart: false,
    
    // store the image protected stats chart object here
    imageProtectedChart: false,
    
    // this contains the pagination object for agent clients
    agentPagination: false,
    
    // this contains the pagination object for image machines
    imagePagination: false,
    
    // the number of order per page
    perPage: 10,
    
    // the last data submitted to the API, used to prevent multiple api requests
    lastAgentSubmittedData: {},
    
    // the last data submitted to the API, used to prevent multiple api requests
    lastImageSubmittedData: {},
    
    // if this ebaas has image data or management
    hasImage: false,

    // if this ebaas has agent data or management
    hasAgent: false,
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        // register the route variables used by this controller
        this._registerRouteVariables();
        
        // set up the pagination
        this._setupPagination();
        
        // register charts 
        this._registerCharts();
        
        PortalHelper.debugMessage('Service Ebaas Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the pagination events
        this.agentPagination.init();
        
        // register the pagination events
        this.imagePagination.init();
    
        // get and populate the order
        this._getOrder();
        
        // get/populate the Ebaas specific order info
        this._getEbOrder();
        
        // register the events used by this controller
        this._registerEvents();
        
        PortalHelper.debugMessage('Service Ebaas Controller Ran');
    },
    
    // get the route variables and include them in the controller
    _registerRouteVariables: function() 
    {
        var segments = PortalMain.getRouteSegments();
        
        // set the base order id
        if (segments.length == 1) {
            this.baseOrderId = segments[0];
        } else {
            // the uri is missing important pieces
            PortalHelper.sendToDashboard();
        }
    },
    
    // create the pagination object
    _setupPagination: function()
    {
        var agentPagination = new PortalPagination();
        agentPagination.urlParamKeys = {
            page: 'agent-page',
            sort: 'agent-sort',
            order: 'agent-order',
            search: 'agent-search',
        };
        agentPagination.perPage = this.perPage;
        agentPagination.paginationSelector = '#agent-clients-pagination';
        agentPagination.contentSelector = '#agent-clients-table';
        agentPagination.searchSelector = '#agent-clients-search';
        agentPagination.searchColumn = 'search_all';
        agentPagination.eventCallback = PortalMain.ServiceEbController._getEbAgentClients;
        PortalMain.ServiceEbController.agentPagination = agentPagination;
        
        var imagePagination = new PortalPagination();
        imagePagination.urlParamKeys = {
            page: 'image-page',
            sort: 'image-sort',
            order: 'image-order',
            search: 'image-search',
        };
        imagePagination.perPage = this.perPage;
        imagePagination.paginationSelector = '#image-clients-pagination';
        imagePagination.contentSelector = '#image-clients-table';
        imagePagination.searchSelector = '#image-clients-search';
        imagePagination.searchColumn = 'search_all';
        imagePagination.eventCallback = PortalMain.ServiceEbController._getEbImageMachines;
        PortalMain.ServiceEbController.imagePagination = imagePagination;
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        // bind to any of the dropdown links
        PortalHelper.hideDropdownOnClick('#range-selection-dropdown');
        $('#range-selection-dropdown ul li a').on('click', function(){
            PortalMain.ServiceEbController._updateChartRange(
                this.dataset.timelineRangeSeconds
            );
            
            PortalMain.ServiceEbController._updateSelectedRange(this);
        });
    },
    
    // register the chart
    _registerCharts: function()
    {
        // new chart for agent client count history
        var agentClientCountChart = new PortalChart;
        agentClientCountChart.elementId = 'agent-client-count-chart';
        agentClientCountChart.type = 'line';
        agentClientCountChart.dataFormat = 'number';
        agentClientCountChart.columns = [];
        this.agentClientCountChart = agentClientCountChart;
        
        // new chart for agent protected stats history
        var agentProtectedChart = new PortalChart;
        agentProtectedChart.elementId = 'agent-protected-chart';
        agentProtectedChart.type = 'line';
        agentProtectedChart.dataFormat = 'bytes';
        agentProtectedChart.columns = [];
        this.agentProtectedChart = agentProtectedChart;
        
        // new chart for image client count history
        var imageClientCountChart = new PortalChart;
        imageClientCountChart.elementId = 'image-client-count-chart';
        imageClientCountChart.type = 'line';
        imageClientCountChart.dataFormat = 'number';
        imageClientCountChart.columns = [];
        this.imageClientCountChart = imageClientCountChart;
        
        // new chart for image protected stats history
        var imageProtectedChart = new PortalChart;
        imageProtectedChart.elementId = 'image-protected-chart';
        imageProtectedChart.type = 'line';
        imageProtectedChart.dataFormat = 'bytes';
        imageProtectedChart.columns = [];
        this.imageProtectedChart = imageProtectedChart;
    },
    
    // get the orders from the api
    _getOrder: function()
    {
        PortalMain.ServiceIndexController = new ServiceIndexController;
        
        PortalMain.ServiceIndexController.baseOrderId = this.baseOrderId;
        
        PortalMain.ServiceIndexController._getOrder();
    },
    
    // get EbaaS specific order info (usage information)
    _getEbOrder: function()
    {
        var ebOrderRequest = new PortalRequest;
        ebOrderRequest.errorElement = '.order-fail';
        ebOrderRequest.makeRequest(
            '/orders-eb/get-order-eb',
            {
                baseOrderId: this.baseOrderId,
            },
            function(data) {
                
                // set image and/or agent
                PortalMain.ServiceEbController._populateHasImageAgent(data);
                
                // register tabs based on eb data
                PortalMain.ServiceEbController._registerTabs(data);
                
                // fill in the stats section
                PortalMain.ServiceEbController._populateEbOrderStats(data);

                // fill in the rates section
                PortalMain.ServiceEbController._populateEbOrderRates(data);
                
                // get the orders stats
                PortalMain.ServiceEbController._getEbStats();
                
                // get the orders vms
                PortalMain.ServiceEbController._getEbAgentClients();
                
                // get the orders vms
                PortalMain.ServiceEbController._getEbImageMachines();
                
            },
            function() {
                // no ds order found, so hide the content
                $('#eb-content').addClass('hidden');
            }
        )
    },
    
    // store the ebaas image or agent components
    _populateHasImageAgent: function(ebInfo)
    {
        this.hasAgent = ebInfo.em_applies || ebInfo.ea_applies;
        this.hasImage = ebInfo.im_applies || ebInfo.ei_applies;
    },
    
    // setup or remove the tabs
    _registerTabs: function(ebInfo)
    {
        if (this.hasAgent && this.hasImage) {
            
            var buttonTabs = new PortalButtonTabs;
            buttonTabs.tabClickCallback = PortalMain.ServiceEbController._chartsTabClickCallback;
            buttonTabs.init('.button-tabs');
            $('.button-tabs').removeClass('hidden');
        } else {
            // remove the tab components
            $('.button-tab-target.current').removeClass('current');
            $('.button-tab-target').removeClass('button-tab-target');
            $('.button-tabs').remove();
        }
    },

    // redraw the chart to fill the now visible space
    _chartsTabClickCallback: function(tabTarget)
    {
        PortalMain.ServiceEbController.agentClientCountChart.draw();
        PortalMain.ServiceEbController.agentProtectedChart.draw();
        PortalMain.ServiceEbController.imageClientCountChart.draw();
        PortalMain.ServiceEbController.imageProtectedChart.draw();
    },
    
    // populate document with usage information
    _populateEbOrderStats: function(ebInfo)
    {
        if (!this.hasAgent) {
            $('#agent-container').remove();
        }
        
        // show the agent matchine stats
        if (ebInfo.em_applies) {
            // set the client count
            $('#em-client-count').text(ebInfo.avamar.node_count);
            
            // set the client rate
            var clientRate = ebInfo.avamar.node_count_rate;
            clientRate = PortalHelper.numberToDollars(clientRate, 2, true);
            $('#em-client-rate').text(clientRate);
            
            // set the client total
            var clientTotal = ebInfo.avamar.node_count_amount;
            clientTotal = PortalHelper.numberToDollars(clientTotal);
            $('#em-client-total').text(clientTotal);
            
            // set the date
            var date = PortalHelper.formatDate(ebInfo.avamar.display_date);
            $('#em-stats .date').text(date);
            
            PortalHelper.loadingOverlay('#em-stats', false);
        } else {
            $('.em-stats').remove();
        }
        
        // show the agent storage stats
        if (ebInfo.ea_applies) {
            // set the protected data
            var protectedData = ebInfo.avamar.bytes_protected;
            protectedData = PortalHelper.formatBytes(protectedData);
            $('#ea-protected-data span:nth-child(1)').text(protectedData[0]);
            $('#ea-protected-data span:nth-child(2)').text(protectedData[1]);
            
            // set the protected rate
            var protectedRate = ebInfo.avamar.gb_protected_rate;
            protectedRate = PortalHelper.numberToDollars(protectedRate, 2, true);
            $('#ea-protected-rate').text(protectedRate);
            
            // set the protected total
            var protectedTotal = ebInfo.avamar.gb_protected_amount;
            protectedTotal = PortalHelper.numberToDollars(protectedTotal);
            $('#ea-protected-total').text(protectedTotal);
            
            // set the date
            var date = PortalHelper.formatDate(ebInfo.avamar.display_date);
            $('#ea-stats .date').text(date);
            
            PortalHelper.loadingOverlay('#ea-stats', false);
        } else {
            $('#ea-stats').remove();
        }
        
        
        if (!this.hasImage) {
            $('#image-container').remove();
        }
        
        // show the image matchine stats
        if (ebInfo.im_applies) {
            // set the client count
            $('#im-client-count').text(ebInfo.rubrik.vm_count);
            
            // set the client rate
            var clientRate = ebInfo.rubrik.vm_count_rate;
            clientRate = PortalHelper.numberToDollars(clientRate, 2, true);
            $('#im-client-rate').text(clientRate);
            
            // set the client total
            var clientTotal = ebInfo.rubrik.vm_count_amount;
            clientTotal = PortalHelper.numberToDollars(clientTotal);
            $('#im-client-total').text(clientTotal);
            
            // set the date
            var date = PortalHelper.formatDate(ebInfo.rubrik.display_date);
            $('#im-stats .date').text(date);
            
            PortalHelper.loadingOverlay('#im-stats', false);
        } else {
            $('#im-stats').remove();
        }
        
        // show the image storage stats
        if (ebInfo.ei_applies) {
            // set the protected data
            var protectedData = ebInfo.rubrik.total_bytes;
            protectedData = PortalHelper.formatBytes(protectedData);
            $('#ei-protected-data span:nth-child(1)').text(protectedData[0]);
            $('#ei-protected-data span:nth-child(2)').text(protectedData[1]);
            
            // set the protected rate
            var protectedRate = ebInfo.rubrik.total_gb_rate;
            protectedRate = PortalHelper.numberToDollars(protectedRate, 2, true);
            $('#ei-protected-rate').text(protectedRate);
            
            // set the protected total
            var protectedTotal = ebInfo.rubrik.total_gb_amount;
            protectedTotal = PortalHelper.numberToDollars(protectedTotal);
            $('#ei-protected-total').text(protectedTotal);
            
            // set the date
            var date = PortalHelper.formatDate(ebInfo.rubrik.display_date);
            $('#ei-stats .date').text(date);
            
            PortalHelper.loadingOverlay('#ei-stats', false);
        } else {
            $('#ei-stats').remove();
        }
        
        // don't show theimage stats if nothing applies
        if (!ebInfo.im_applies && !ebInfo.ei_applies) {
            $('#image-stats').remove();
        }
        
    },

    // fill in and display the per GB rate
    _populateEbOrderRates: function(ebInfo)
    {
        // set the per gb rate
        if (ebInfo.avamar.gb_protected_rate != undefined) {
            var perGbRate = $('#usage-rates .clone-source').clone();
            perGbRate.removeClass('clone-source');

            $('.rate-label', perGbRate).text('Per GB Rate');

            var rate = ebInfo.avamar.gb_protected_rate;
            rate = PortalHelper.numberToDollars(rate, 2, true);
            $('.rate-amount', perGbRate).text(rate);

            $('#usage-rates').append(perGbRate);
        }

        // set the per vm rate
        if (ebInfo.avamar.node_count_rate != undefined) {
            var perLocalGbRate = $('#usage-rates .clone-source').clone();
            perLocalGbRate.removeClass('clone-source');

            $('.rate-label', perLocalGbRate).text('Per VM Rate');

            var rate = ebInfo.avamar.node_count_rate;
            rate = PortalHelper.numberToDollars(rate, 2, true);
            $('.rate-amount', perLocalGbRate).text(rate);

            $('#usage-rates').append(perLocalGbRate);
        }

        // set the per gb rate
        if (ebInfo.rubrik.total_gb_rate != undefined) {
            var perGbRate = $('#usage-rates .clone-source').clone();
            perGbRate.removeClass('clone-source');

            $('.rate-label', perGbRate).text('Per GB Rate');

            var rate = ebInfo.rubrik.total_gb_rate;
            rate = PortalHelper.numberToDollars(rate, 2, true);
            $('.rate-amount', perGbRate).text(rate);

            $('#usage-rates').append(perGbRate);
        }

        // set the per vm rate
        if (ebInfo.rubrik.vm_count_rate != undefined) {
            var perLocalGbRate = $('#usage-rates .clone-source').clone();
            perLocalGbRate.removeClass('clone-source');

            $('.rate-label', perLocalGbRate).text('Per VM Rate');

            var rate = ebInfo.rubrik.vm_count_rate;
            rate = PortalHelper.numberToDollars(rate, 2, true);
            $('.rate-amount', perLocalGbRate).text(rate);

            $('#usage-rates').append(perLocalGbRate);
        }

        // show the usage rates
        $('#usage-rates').removeClass('hidden');
    },

    // retrieves the timeline ebaas stats
    _getEbStats: function(startDate, endDate)
    {
        // defaulting to 1 week range if a start or end date not passed
        if(!(startDate instanceof Date) || !(endDate instanceof Date)) {
            var startDate = new Date();
            var endDate = new Date();
            
            startDate.setMonth(
                startDate.getMonth() - 1
            );
        }
        
        var ebStatsRequest = new PortalRequest;
        ebStatsRequest.makeRequest(
            '/orders-eb/get-eb-stats',
            {
                baseOrderId: this.baseOrderId,
                // Date() strikes again. Dividing by 1000 here to get seconds instead of ms
                startDate: startDate.getTime() / 1000|0,
                endDate: endDate.getTime() / 1000|0,
            },
            function(data) {
                PortalMain.ServiceEbController._populateAgentClientCountChart(data.agent, startDate, endDate);
                PortalMain.ServiceEbController._populateAgentProtectedChart(data.agent, startDate, endDate);
                PortalMain.ServiceEbController._populateImageClientCountChart(data.image, startDate, endDate);
                PortalMain.ServiceEbController._populateImageProtectedChart(data.image, startDate, endDate);
            }
        );
    },
    
    // sets up the vm count graph, populating columns and data
    _populateAgentClientCountChart: function(chartData, startDate, endDate)
    {
        if (this.hasAgent) {
            // keep only the specified columns for the chart
            chartData = PortalHelper.chartGetColumns(chartData, [
                'Time',
                'Machine Count'
            ]);
            
            this.agentClientCountChart.minDate = startDate;
            this.agentClientCountChart.maxDate = endDate;
            // resetting columns first
            this.agentClientCountChart.columns = [];
            for(var i in chartData[0]) {
                var currentField = chartData[0][i];
                if(currentField == 'Time') {
                    this.agentClientCountChart.columns[i] = ['date', currentField];
                } else {
                    this.agentClientCountChart.columns[i] = ['number', currentField];
                }
            }
            
            if(chartData.length == 1) {
                $('#client-count-chart').text("No data available for this period.");
            } else {
                this.agentClientCountChart.data = chartData;
                this.agentClientCountChart.draw();
            }
            PortalHelper.loadingOverlay('#agent-client-count-chart', false);   
        }     
    },
    
    // sets up the protected graph, populating columns and data
    _populateAgentProtectedChart: function(chartData, startDate, endDate)
    {
        if (this.hasAgent) {
            // keep only the specified columns for the chart
            chartData = PortalHelper.chartGetColumns(chartData, [
                'Time',
                'Aggregate Size'
            ]);
            
            this.agentProtectedChart.minDate = startDate;
            this.agentProtectedChart.maxDate = endDate;
            // resetting columns first
            this.agentProtectedChart.columns = [];
            for(var i in chartData[0]) {
                var currentField = chartData[0][i];
                if(currentField == 'Time') {
                    this.agentProtectedChart.columns[i] = ['date', currentField];
                } else {
                    this.agentProtectedChart.columns[i] = ['number', currentField];
                }
            }
            
            if(chartData.length == 1) {
                $('#protected-chart').text("No data available for this period.");
            } else {
                this.agentProtectedChart.data = chartData;
                this.agentProtectedChart.draw();
            }
            PortalHelper.loadingOverlay('#agent-protected-chart', false);        
        }
    },
    
    // sets up the vm count graph, populating columns and data
    _populateImageClientCountChart: function(chartData, startDate, endDate)
    {
        if (this.hasImage) {
            // keep only the specified columns for the chart
            chartData = PortalHelper.chartGetColumns(chartData, [
                'Time',
                'Machine Count'
            ]);
            
            this.imageClientCountChart.minDate = startDate;
            this.imageClientCountChart.maxDate = endDate;
            // resetting columns first
            this.imageClientCountChart.columns = [];
            for(var i in chartData[0]) {
                var currentField = chartData[0][i];
                if(currentField == 'Time') {
                    this.imageClientCountChart.columns[i] = ['date', currentField];
                } else {
                    this.imageClientCountChart.columns[i] = ['number', currentField];
                }
            }
            
            if(chartData.length == 1) {
                $('#client-count-chart').text("No data available for this period.");
            } else {
                this.imageClientCountChart.data = chartData;
                this.imageClientCountChart.draw();
            }
            PortalHelper.loadingOverlay('#image-client-count-chart', false);   
        }     
    },
    
    // sets up the protected graph, populating columns and data
    _populateImageProtectedChart: function(chartData, startDate, endDate)
    {
        if (this.hasImage) {
            // keep only the specified columns for the chart
            chartData = PortalHelper.chartGetColumns(chartData, [
                'Time',
                'Storage Consumed'
            ]);
            
            this.imageProtectedChart.minDate = startDate;
            this.imageProtectedChart.maxDate = endDate;
            // resetting columns first
            this.imageProtectedChart.columns = [];
            for(var i in chartData[0]) {
                var currentField = chartData[0][i];
                if(currentField == 'Time') {
                    this.imageProtectedChart.columns[i] = ['date', currentField];
                } else {
                    this.imageProtectedChart.columns[i] = ['number', currentField];
                }
            }
            
            if(chartData.length == 1) {
                $('#protected-chart').text("No data available for this period.");
            } else {
                this.imageProtectedChart.data = chartData;
                this.imageProtectedChart.draw();
            }
            PortalHelper.loadingOverlay('#image-protected-chart', false);     
        }   
    },
    
    // changes what date range is displayed
    _updateChartRange: function(dateRangeSeconds)
    {
        PortalHelper.loadingOverlay('#agent-client-count-chart', true);
        PortalHelper.loadingOverlay('#agent-protected-chart', true);
        var endDate = new Date();
        var startDate = new Date(
            endDate.getTime() 
            - (dateRangeSeconds * 1000)
        );
        
        this._getEbStats(startDate, endDate);
    },
    
    // adds interactivity to the dropdown range selection
    _updateSelectedRange: function(element)
    {
        var selectedElementText = $(element).text();
        $('.selection-text').text(selectedElementText);
    },
    
    // retrieves the vms of the ebaas order
    _getEbAgentClients: function()
    {   
        if (!PortalMain.ServiceEbController.hasAgent) {
            $('#agent-machines').remove();
        }
        
        // get the submission data from the pagination object
        var submissionData = PortalMain.ServiceEbController.agentPagination.getBaseSubmissionData();
        
        // include the base order id
        submissionData.baseOrderId = PortalMain.ServiceEbController.baseOrderId;
        
        // make sure the new request isn't the same as the previous one
        if (JSON.stringify(submissionData) == JSON.stringify(PortalMain.ServiceEbController.lastAgentSubmittedData)) {
            PortalMain.ServiceEbController.agentPagination.showPagination();
            return;
        }
        PortalMain.ServiceEbController.lastAgentSubmittedData = submissionData;
        
        // make the request
        var ebAgentClientsRequest = new PortalRequest;
        ebAgentClientsRequest.pageNumber = submissionData.page;
        ebAgentClientsRequest.makeRequest(
            '/orders-eb/get-eb-agent-clients',
            submissionData,
            function(data) {
                
                //handle pagination 
                PortalMain.ServiceEbController.agentPagination.updatePagination(data);
                PortalMain.ServiceEbController.agentPagination.showPagination();
                
                // get the last pagination event
                var lastEvent = PortalMain.ServiceEbController.agentPagination.lastEvent;
                
                // fill the clients table
                PortalMain.ServiceEbController._populateAgentClientsTable(data, lastEvent);
            }
        );
    },
    
    // populate the agent clients table
    _populateAgentClientsTable: function(clientsData, lastPaginationEvent)
    {   
        var clients = clientsData.data;
        
        // clear the old vms
        if (lastPaginationEvent != 'more') {
            $('#agent-clients-table tbody tr:not(.clone-source)').remove();
        }
        
        // add the new vms to the DOM
        for (var i in clients) {
            var client = clients[i];
            var newEntry = $('#agent-clients-table tbody .clone-source').clone();
            newEntry.removeClass('clone-source');
            
            // apply the client name
            $('.client-name', newEntry).html(client.client_name);
            
            // apply the client link
            var clientLink = PortalConfig.portalUrl;
            clientLink += '/service/eb-agent-machine';
            clientLink += '/' + this.baseOrderId;
            clientLink += '/' + client.client_name;
            $('.client-name', newEntry).attr('href', clientLink);
            
            var totalProtected = client.total_bytes_protected
            totalProtected = PortalHelper.formatBytes(totalProtected, 'GB');
            $('.total-protected', newEntry).html(totalProtected);
            
            // add to to the table
            $('#agent-clients-table tbody').append(newEntry);
        }
        
    },
    
    // retrieves the vms of the ebaas order
    _getEbImageMachines: function()
    {   
        if (!PortalMain.ServiceEbController.hasImage) {
            $('#image-machines').remove();
        }
        
        // get the submission data from the pagination object
        var submissionData = PortalMain.ServiceEbController.imagePagination.getBaseSubmissionData();
        
        // include the base order id
        submissionData.baseOrderId = PortalMain.ServiceEbController.baseOrderId;
        
        // make sure the new request isn't the same as the previous one
        if (JSON.stringify(submissionData) == JSON.stringify(PortalMain.ServiceEbController.lastImageSubmittedData)) {
            PortalMain.ServiceEbController.imagePagination.showPagination();
            return;
        }
        PortalMain.ServiceEbController.lastImageSubmittedData = submissionData;
        
        // make the request
        var ebImageMachinesRequest = new PortalRequest;
        ebImageMachinesRequest.pageNumber = submissionData.page;
        ebImageMachinesRequest.makeRequest(
            '/orders-eb/get-eb-image-machines',
            submissionData,
            function(data) {
                
                //handle pagination 
                PortalMain.ServiceEbController.imagePagination.updatePagination(data);
                PortalMain.ServiceEbController.imagePagination.showPagination();
                
                // get the last pagination event
                var lastEvent = PortalMain.ServiceEbController.imagePagination.lastEvent;
                
                // fill the clients table
                PortalMain.ServiceEbController._populateImageMachinesTable(data, lastEvent);
            }
        );
    },
    
    // populate the agent clients table
    _populateImageMachinesTable: function(vmsData, lastPaginationEvent)
    {   
        var vms = vmsData.data;
        
        // clear the old vms
        if (lastPaginationEvent != 'more') {
            $('#image-clients-table tbody tr:not(.clone-source)').remove();
        }
        
        // add the new vms to the DOM
        for (var i in vms) {
            var vm = vms[i];
            var newEntry = $('#image-clients-table tbody .clone-source').clone();
            newEntry.removeClass('clone-source');
            
            // apply the client name
            $('.machine-name', newEntry).html(vm.vm_name);
            
            // apply the client link
            var vmLink = PortalConfig.portalUrl;
            vmLink += '/service/eb-image-machine';
            vmLink += '/' + this.baseOrderId;
            vmLink += '/' + vm.vm_name;
            $('.machine-name', newEntry).attr('href', vmLink);
            
            // apply the storage
            var totalLocalStorage = vm.total_local_storage_bytes;
            totalLocalStorage = PortalHelper.formatBytes(totalLocalStorage, 'GB');
            $('.total-local-storage', newEntry).html(totalLocalStorage);
            
            // apply the total snapshots
            var totalSnapshots = vm.total_snapshots;
            $('.total-snapshots', newEntry).html(totalSnapshots);
            
            // apply the missed snapshots
            var missedSnapshots = vm.missed_snapshots;
            $('.missed-snapshots', newEntry).html(missedSnapshots);
            
            // apply the last snapshot
            var lastSnapshot = PortalHelper.formatDate(vm.last_snapshot);
            lastSnapshot += '&nbsp;';
            lastSnapshot += PortalHelper.formatTime(vm.last_snapshot);
            $('.last-snapshot', newEntry).html(lastSnapshot);
            
            // add to to the table
            $('#image-clients-table tbody').append(newEntry);
        }
        
    },
}